import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core'
import { RouterModule } from '@angular/router'
import { CommonModule } from '@angular/common'
import { Subscription } from 'rxjs/internal/Subscription'
import { interval } from 'rxjs/internal/observable/interval'
import { trigger, state, style, transition, animate } from '@angular/animations'
import { RemoveTildesPipe } from '../../../../shared/pipes/remove-tildes.pipe'
import { Banner } from '../../../../core/models/metrics.model'
import { ScoresService } from '../../../scores/services/scores.service'
import { StreamService } from '../../services/stream.service'
import { MatIconModule } from '@angular/material/icon'
import { PlayerCardComponent } from '../../../players/player-card/player-card.component'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'

@Component({
    selector: 'superordenador-component',
    standalone: true,
    imports: [
        CommonModule,
        RouterModule,
        RemoveTildesPipe,
        PlayerCardComponent,
        MatProgressSpinnerModule,
        MatIconModule
    ],
    animations:[
      trigger('fade', [
        state('visible', style({ opacity: 1 })),
        state('hidden', style({ opacity: 0 })),
        transition('visible => hidden', [animate('0.5s ease-out')]),
        transition('hidden => visible', [animate('0.5s ease-in')]),
      ])
    ],
    templateUrl: 'superordenador.component.html',
    styleUrl: './superordenador.component.css'
})
export class SuperordenadorComponent implements OnInit, OnDestroy {
  banners: Banner[] = []
  currentBannerIndex = 0
  animationState = 'visible'
  loading = true

  banner: Banner = {
    type: '',
    name: '',
    competition: '',
    data: [],
  }

  private subscription: Subscription = new Subscription()
  
  constructor(
    private service: StreamService,
    private scoresService: ScoresService
  ){}

  ngOnInit() {
    this.subscription.add(
      this.service.getBannersData()
      .subscribe(response => {
        /*
        (response as Banner[]).forEach(async (banner, index)=>{
          if(banner.type == 'Ranking')
          banner.data.forEach(async (element, index)=>{
            //if(element.player) element.player.foto = await this.scoresService.fetchFoto(element.player._id)
          })
          //if(banner.type == 'Player' && banner.data.length < 4 && banner.player)
            //banner.player.foto = await this.scoresService.fetchFoto(banner.player._id)
        })*/
        this.banners = (response as Banner[])
        this.currentBannerIndex = 0
        this.banner = this.banners[this.currentBannerIndex]

        this.checkTitleAnimation()
        this.checkMetricLength()

        this.loading = false
      })
    )

    this.subscription.add(
      interval(22000).subscribe(() => {
        this.animateBannerChange()
      })
    )

    this.subscription.add(
      this.service.bannerUpdatedEvent.subscribe(updatedBanner => {
        const index = this.banners.findIndex(b=>b.type == 'Match')
        if (index >= 0) this.banners[index] = updatedBanner
      })
    )
  }

  animateBannerChange(){
    this.animationState = 'hidden'
    setTimeout(() => {
      this.currentBannerIndex = (this.currentBannerIndex + 1) % this.banners.length
      this.banner = this.banners[this.currentBannerIndex]
      this.animationState = 'visible'
      this.checkTitleAnimation()
      this.checkMetricLength()
    }, 500);
  }

  checkTitleAnimation(){
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      return;
    }
    setTimeout(() => {
      const nameElements = document.querySelectorAll('.name')
      const containers = document.querySelectorAll('.name-container')

      nameElements.forEach((nameElement, index) => {
        const container = containers[index]
        if (container && nameElement.scrollWidth >= container.clientWidth)
          nameElement.classList.add('animated-name')
        else nameElement.classList.remove('animated-name')
      })
    }, 100)
  }

  checkMetricLength(){
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      return;
    }

    setTimeout(() => {
      const nameElements = document.querySelectorAll('.label')
      const containers = document.querySelectorAll('.metric')

      nameElements.forEach((nameElement, index) => {
        const lineHeight = parseFloat(getComputedStyle(nameElement).lineHeight) + 5
        const height = nameElement.clientHeight
        const container = containers[index]

        if (height > lineHeight)
          container.classList.add('multiline')
        else container.classList.remove('multiline')
      })
    }, 100)
  }

  getColor(competition:string){
    var color = '#c30913'
    switch(competition){
      case 'Champions League':
        color = '#4464ad'
        break
      case 'Club World Cup':
      case 'Copa del Rey':
        color = '#121215'
        break
    }
    return `linear-gradient(to right, ${color} 20%, rgba(255,255,255,0) 50%)`
  }
  getFoto(competition:string){
    switch(competition){
      case 'LALIGA':
        return 'https://assets.laliga.com/assets/logos/LL_RGB_h_monocromo_positivo/LL_RGB_h_monocromo_positivo.png'
      case 'Champions League':
        return 'https://i.pinimg.com/originals/5f/32/84/5f32846ad37b4e9a20fb3bcd085bc0d8.png'
      case 'Copa del Rey':
        return 'https://brandlogos.net/wp-content/uploads/2022/08/copa_del_rey-logo_brandlogos.net_mm7fh.png'
      case 'Primera RFEF':
        return 'https://upload.wikimedia.org/wikipedia/commons/thumb/d/d2/Primera_Federaci%C3%B3n.svg/1200px-Primera_Federaci%C3%B3n.svg.png'
      case 'Youth League':
        return 'https://upload.wikimedia.org/wikipedia/commons/thumb/8/82/UEFA_Youth_League.svg/2048px-UEFA_Youth_League.svg.png'
      case 'Club World Cup':
        return 'https://atleticostats.fra1.cdn.digitaloceanspaces.com/logos/ClubWorldCup.png'
      case 'Torneo Futbol Callejero':
        return 'https://atleticostats.fra1.cdn.digitaloceanspaces.com/logos/TorneoFutbolCallejero.png'
      default:
        return ''
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe()
  }
}